import { render } from "./ModalSettings.vue?vue&type=template&id=909b7ab0&scoped=true"
import script from "./ModalSettings.vue?vue&type=script&lang=js"
export * from "./ModalSettings.vue?vue&type=script&lang=js"

import "./ModalSettings.vue?vue&type=style&index=0&id=909b7ab0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-909b7ab0"]])

export default __exports__